export const environment = {
  "production": "true",
  "gatewayApiUrl": "https://gateway.garant.doorit.de/graphql",
  "imageApiUrl": "",
  "keycloakConfig": {
    "url": "https://keycloak.doorit.de",
    "realm": "garant",
    "clientId": "frontend-garant"
  }
};